const CHANNEL_NAME = 'project-roach-tabs';
const LEASE_KEY = 'project-roach.active-tab';
const LEASE_MS = 5000;

interface Lease {
  tabId: string;
  expiresAt: number;
}

export class TabCoordinator {
  readonly tabId = crypto.randomUUID();
  private channel: BroadcastChannel | null = null;
  private intervalId: number | null = null;
  private owner = false;

  start(onOwnershipChange: (isOwner: boolean) => void): () => void {
    if ('BroadcastChannel' in window) {
      this.channel = new BroadcastChannel(CHANNEL_NAME);
      this.channel.onmessage = () => this.refresh(onOwnershipChange);
    }
    this.takeOwnership();
    this.refresh(onOwnershipChange);
    this.intervalId = window.setInterval(() => {
      if (this.owner) this.writeLease();
      this.refresh(onOwnershipChange);
    }, 2000);

    return () => {
      if (this.intervalId) window.clearInterval(this.intervalId);
      this.channel?.close();
      const lease = this.readLease();
      if (lease?.tabId === this.tabId) localStorage.removeItem(LEASE_KEY);
    };
  }

  takeOwnership(): void {
    this.owner = true;
    this.writeLease();
    this.channel?.postMessage({ owner: this.tabId });
  }

  get isOwner(): boolean {
    return this.owner;
  }

  private refresh(onOwnershipChange: (isOwner: boolean) => void): void {
    const lease = this.readLease();
    const next = !lease || lease.expiresAt <= Date.now() || lease.tabId === this.tabId;
    if (next !== this.owner) {
      this.owner = next;
      onOwnershipChange(next);
    }
  }

  private writeLease(): void {
    localStorage.setItem(LEASE_KEY, JSON.stringify({ tabId: this.tabId, expiresAt: Date.now() + LEASE_MS } satisfies Lease));
  }

  private readLease(): Lease | null {
    try {
      return JSON.parse(localStorage.getItem(LEASE_KEY) ?? 'null') as Lease | null;
    } catch {
      return null;
    }
  }
}
